import { Injectable, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';

@Injectable()
export class AdminService {

  constructor(@Inject(Restangular) public Restangular) {

  }

  public addUser(id: any, user: any) {
    if (id) {
      return this.Restangular.all('users/' + id).customPUT(user);
    } else {
      return this.Restangular.all('users').customPOST(user);
    }
  }

  public getUsers(currentPage: any, filters: any) {
    debugger;
    return this.Restangular.all('users?page=' + currentPage + filters).customGET('');
  }

  public getUser(id: any) {
    debugger;
    return this.Restangular.all('users/' + id).customGET('');
  }

  public getProfiles(currentPage: any, filters: any) {
    debugger;
    return this.Restangular.all('profiles?page=' + currentPage + filters).customGET('');
  }

  public getProfile(id: any, filters = null) {
    debugger;
    return this.Restangular.all('profiles/' + id + filters).customGET('');
  }

  public getUserProfile(id: any) {
    debugger;
    return this.Restangular.all('profiles/user/' + id).customGET('');
  }

  public getCustomerTransactions(id: any, filters = null) {
    debugger;
    return this.Restangular.all('transactions/user/' + id + filters).customGET('');
  }

  public getCustomerNotifications(id: string) {
    debugger;
    return this.Restangular.all('notifications/user/' + id).customGET('');
  }

  public getCustomerAwards(id: string, filter: string) {
    debugger;
    return this.Restangular.all('awards/user/' + id + filter).customGET('');
  }

  public getCustomerSales(id: string) {
    debugger;
    return this.Restangular.all('sales/user/' + id + '/sales').customGET('');
  }

  public getCustomerOffers(id: string) {
    debugger;
    return this.Restangular.all('sales/user/' + id + '/sales').customGET('');
  }

  public changeTransactionStatus(id: string, status: string) {
    return this.Restangular.one(`transactions/${id}/${status}`).customPUT('');
  }

  public changeUserekubStatus(dto: any) {
    debugger;
    return this.Restangular.one('ekubs/member/status').customPUT(dto);
  }

  public addCustomer(id: any, customer: any) {
    if (id) {
      return this.Restangular.all('profiles/' + id).customPUT(customer);
    } else {
      return this.Restangular.all('profiles').customPOST(customer);
    }
  }


  public addRole(id: any, user: any) {
    if (id) {
      return this.Restangular.all('roles/' + id).customPUT(user);
    } else {
      return this.Restangular.all('roles').customPOST(user);
    }
  }

  public getRoles(currentPage: any, filters: any) {
    debugger;
    return this.Restangular.all('roles?page=' + currentPage + filters).customGET('');
  }

  public getRole(id: any) {
    debugger;
    return this.Restangular.all('roles/' + id).customGET('');
  }

  public getAllEkubs(filter: string) {
    debugger;
    return this.Restangular.all('ekubs' + filter).customGET('');
  }

  getEkubMembers(id: String) {
    debugger;
    return this.Restangular.one('ekubs/' + id + '/members').customGET('');
  }

  public enrollUser(dto: any, option: string = null) {
    debugger;
    return this.Restangular.all('ekubs/member/enroll' + option).customPOST(dto);
  }

  public changeUserStatus(userId: any, status: any) {
    return this.Restangular.all('users/' + userId + '/' + status).customPUT();
  }

  public changeProfileStatus(profileId: any, status: any) {
    return this.Restangular.all('profiles/' + profileId + '/' + status).customPUT();
  }

  public changeUserVerificationStatus(userId: any, status: number) {
    debugger;
    return this.Restangular.all('users/' + userId + '/verify/' + status).customPUT();
  }

  createNotification(notification: object, id: string = null) {
    debugger;
    if (id != null) {
      return this.Restangular.one('notifications/' + id).customPUT(notification);
    }
    return this.Restangular.one('notifications').customPOST(notification);
  }

  broadcastNotification(id: string, notification: object, options: string) {
    debugger;
    return this.Restangular.all('notifications/ekub/' + id + options).customPOST(notification);
    //return this.Restangular.one(`notifications/members/ekub/${id}`).customPOST(notification);
  }

  public changeNotificationStatus(id: any, status: any) {
    return this.Restangular.all('notifications/' + id + '/' + status).customPUT();
  }

  public getNotifications(currentPage: any, filters: any) {
    return this.Restangular.all('notifications?page=' + currentPage + filters).customGET('');
  }

  createAnnouncement(announcement: object, id: string) {
    debugger;
    if (id != null) {
      return this.Restangular.one('notifications/announcements/update/' + id).customPUT(announcement);
    }
    return this.Restangular.one('notifications/announcements').customPOST(announcement);
  }

  public changeAnnouncementStatus(id: any, status: any) {
    return this.Restangular.all('notifications/announcements/status/' + id + '/' + status).customPUT();
  }

  public getAnnouncements(currentPage: any, filters: any) {
    return this.Restangular.all('notifications/announcements/fetch?page=' + currentPage + filters).customGET('');
  }

  public changeCommentStatus(commentId: any, status: any) {
    debugger;
    return this.Restangular.all('comments/' + commentId + '/' + status).customPUT();
  }

  public getComments(currentPage: any, filters: any) {
    return this.Restangular.all('comments?page=' + currentPage + filters).customGET('');
  }


  public getActivities(currentPage: any, filters: any) {
    debugger;
    return this.Restangular.all('activities?page=' + currentPage + filters).customGET('');
  }

  public getActivity(id: any, filters = null) {
    debugger;
    return this.Restangular.all('activities/' + id + filters).customGET('');
  }

  public changeActivityStatus(activityId: any, status: any) {
    return this.Restangular.all('activities/' + activityId + '/' + status).customPUT();
  }

  public changePassword(dto: any, user: string) {
    debugger;
    return this.Restangular.one('users/' + user + '/passwd/change').customPUT(dto);
  }

  getBranches(filter: String = null) {
    debugger;
    return this.Restangular.one('branches' + filter).customGET('');
  }

  getUserStats(user: string) {
    debugger;
    return this.Restangular.one('ekubs/user/' + user + '/ekubs/stat').customGET('');
  }

  getUserGuarantees(user: string) {
    debugger;
    return this.Restangular.one('guarantees/user/' + user).customGET('');
  }

  changeGuaranteeStatus(guaranteeId: string, status: string) {
    return this.Restangular.all('guarantees/' + guaranteeId + '/' + status).customPUT();
  }

  public getCustomerEkubs(id: string) {
    debugger;
    return this.Restangular.all('ekubs/user/' + id + '/ekubs').customGET('');
  }

  getUserReceipts(user: string, currentPage: number, filter: string = null) {
    debugger;
    return this.Restangular.one('receipts/user/' + user + '?page=' + currentPage + filter).customGET('');
  }

  createReceipt(receipt: object, id: string = null) {
    debugger;
    if (id != null) {
      return this.Restangular.one('receipts/' + id).customPUT(receipt);
    }
    return this.Restangular.one('receipts').customPOST(receipt);
  }

  public changeReceiptStatus(id: any, status: any) {
    return this.Restangular.all('receipts/' + id + '/' + status).customPUT();
  }

}
